/**
 * P3-31: Refine Tears 按钮（x5 / x25 / x100 links）。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import type { GameButtonLinkModel } from "../../components/GameButton";
import { useRefineTearsButtonModel } from "./useReligionModel";
import { t } from "../../bridge/i18n";

interface RefineTearsButtonProps {
  visible?: boolean;
}

export function RefineTearsButton({ visible }: RefineTearsButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useRefineTearsButtonModel(
    t("religion.refineTearsBtn.label"),
    t("religion.refineTearsBtn.desc"),
    [{ name: "tears", val: 10000 }],
  );

  const onClick = useCallback(
    (event: MouseEvent) => {
      if (controller && modelRef.current) {
        controller.buyItem?.(modelRef.current, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }
  if (visible === false) {
    return null;
  }

  const links: GameButtonLinkModel[] = snap.links.map((link) => ({
    title: link.title,
    visible: link.visible,
    handler: link.handler,
  }));

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      links={links}
      getTooltip={getTooltip}
      onClick={onClick}
    />
  );
}
